<template>
  <div class="settings-deleted-patients-container m-4">
    <div
      class="d-flex flex-row justify-content-between align-items-center mb-3"
    >
      <h5 class="mb-0">Deleted Documents</h5>
    </div>
    <div
      class="d-flex flex-row justify-content-between hover-pointer align-items-center mb-2"
    >
      <b-form-input
        style="width:300px"
        v-model="filter.searchPhrase"
        placeholder="Search by Document Ref#, Patient Name or Document Type"
        title="Search by Document Ref#, Patient Name or Document Type"
      />
      <top-paginator
        :total="listTotal"
        :page="filter.page"
        :perPage="filter.pageSize"
        @change-page="changePage"
      />
    </div>
    <div>
      <grid
        class=""
        ref="grid"
        :groupFeature="false"
        :columns="columns"
        :autoHeight="true"
        :data="deletedDocuments"
        :columnLines="false"
        :searchFeature="true"
        :stripeFeature="false"
        @storesort="listeners.storeSort"
      ></grid>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Grid from "../../third_party/grid/Grid.vue";
import TopPaginator from "../controls/TopPaginator.vue";
import { formatDate } from "../../helpers/date";
import documents from "../../server/document";

export default {
  name: "DeletedDocuments",
  components: { Grid, TopPaginator },
  data() {
    const self = this;
    return {
      deletedDocuments: [],
      listTotal: 0,
      filter: {
        page: 0,
        pageSize: 50,
        orderBy: "createdAt",
        orderByDescending: false,
        searchPhrase: ""
      },
      listeners: {
        storeSort: sortData => {
          if (sortData.sorters.length == 1) {
            const sorter = sortData.sorters[0];
            const ascending = sorter.ascending;
            const field = sorter.field;
            self.filter.orderBy = field;
            self.filter.orderByDescending = !ascending;
            self.changePage(0);
          }
        }
      }
    };
  },
  mounted() {
    this.getDeletedDocuments();
  },
  watch: {
    "filter.searchPhrase": function() {
      this.filter.page = 0;
      if (
        this.filter.searchPhrase.length == 0 ||
        this.filter.searchPhrase.length >= 3
      ) {
        this.getDeletedDocuments();
      }
    }
  },
  methods: {
    ...mapActions("layout", ["showAlertSuccess"]),
    async getDeletedDocuments() {
      const result = await documents.findAllDeleted({
        page: this.filter.page,
        pageSize: this.filter.pageSize,
        orderBy: this.filter.orderBy,
        orderByDescending: this.filter.orderByDescending,
        searchPhrase:
          this.filter.searchPhrase.length >= 3 ? this.filter.searchPhrase : ""
      });
      this.deletedDocuments = result.documents;
      this.listTotal = result.count;
    },
    async restoreDocument(data) {
      this.$dialog
        .confirm(
          {
            title: "Are you sure you want to restore this record?"
          },
          {
            view: "confirm"
          }
        )
        .then(async () => {
          await documents.restore(data.id);
          this.showAlertSuccess();
          await this.getDeletedDocuments();
        })
        .catch(function() {});
    },
    async changePage(page) {
      this.filter.page = page;
      this.getDeletedDocuments();
    }
  },
  computed: {
    columns() {
      let columns = [];
      const self = this;

      columns.push({
        text: "Ref#",
        field: "referenceNumber",
        editor: false,
        template: data => data.value,
        width: 150,
        sortable() {
          return self.filter.orderByDescending ? -1 : 1;
        }
      });

      columns.push({
        text: "Created",
        field: "createdAt",
        type: "template",
        width: 250,
        editor: false,
        template: data => formatDate(data.value),
        sortable() {
          return self.filter.orderByDescending ? -1 : 1;
        }
      });

      columns.push({
        text: "Deleted At",
        field: "deletedAt",
        type: "template",
        width: 250,
        editor: false,
        template: data => formatDate(data.record.data.deletedAt)
      });

      columns.push({
        text: "Deleted By",
        field: "deletedBy",
        type: "template",
        flex: 1,
        template: data => data.record.data.deletedBy ?? "",
        sortable() {
          return self.filter.orderByDescending ? -1 : 1;
        }
      });

      columns.push({
        text: "Type",
        field: "type",
        width: 250,
        editor: false,
        sortable() {
          return self.filter.orderByDescending ? -1 : 1;
        }
      });

      columns.push({
        text: "Patient",
        field: "patientName",
        flex: 1,
        editor: false,
        sortable() {
          return self.filter.orderByDescending ? -1 : 1;
        }
      });

      columns.push({
        text: "Effective Date",
        field: "effectiveDate",
        type: "template",
        width: 250,
        editor: false,
        template: data => formatDate(data.value),
        sortable() {
          return self.filter.orderByDescending ? -1 : 1;
        }
      });

      columns.push({
        text: "Actions",
        type: "action",
        cellCls: "pointer-cell",
        align: "right",
        width: 100,
        actions: [
          {
            tooltip: "Restore",
            renderer: () =>
              `<img class="b-action-item ml-2 mr-1" src="${
                this.isStandalone()
                  ? `/icons/restore.svg`
                  : `/desktop/icons/restore.svg`
              }">`,
            onClick: async ({ record }) => {
              await this.restoreDocument(record.data);
            }
          }
        ]
      });

      return columns;
    }
  }
};
</script>

<style>
.settings-deleted-patients-container .b-grid-container .b-container {
  max-height: calc(100vh - 281px);
}
</style>
